import Lazy from '@/utils/Lazy'

export default new Lazy({
  observerOptions: {
    rootMargin: `${window.innerHeight / 2}px ${window.innerWidth / 2}px`
  }
})
